import axios from "../utils/axios";

export const getWhyChooseUsSection = async () => {
    const { data } = await axios.get('/settings/why-choose-us-page');
    return data;
};

export const updateWhyChooseUsSection = async (data) => {
    const { data: response } = await axios.put('/settings/why-choose-us-page', data);
    return response;
};

export const getWhyChooseUsItems = async (params) => {
    const { data } = await axios.get('/why-choose-us', { params });
    return data;
};

export const getWhyChooseUsItemById = async (id) => {
    const { data } = await axios.get(`/why-choose-us/${id}`);
    return data;
};

export const createWhyChooseUsItem = async (itemData) => {
    const { data } = await axios.post('/why-choose-us', itemData);
    return data;
};

export const updateWhyChooseUsItem = async (id, itemData) => {
    const { data } = await axios.put(`/why-choose-us/${id}`, itemData);
    return data;
};

export const deleteWhyChooseUsItem = async (id) => {
    const { data } = await axios.delete(`/why-choose-us/${id}`);
    return data;
};

export const forceDeleteWhyChooseUsItem = async (id) => {
    const { data } = await axios.delete(`/why-choose-us/${id}/force-delete`);
    return data;
};

export const restoreWhyChooseUsItem = async (id) => {
    const { data } = await axios.post(`/why-choose-us/${id}/restore`);
    return data;
};

export const massDestroyWhyChooseUsItems = async (data) => {
    const response = await axios.delete('/why-choose-us/mass-destroy', { data });
    return response.data;
};

export const massForceDeleteWhyChooseUsItems = async (data) => {
    const response = await axios.delete('/why-choose-us/mass-force-delete', { data });
    return response.data;
};

export const massRestoreWhyChooseUsItems = async (data) => {
    const response = await axios.post('/why-choose-us/mass-restore', data);
    return response.data;
};
